import React from 'react'
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/ui/tooltip'
import { GoogleSignIn } from './googleSignIn'
import { MicrosoftSignIn } from './microsoftSignIn'
import { Sidebar } from './sidebar'
import evermuseLogo from '@/assets/evermuse-logo-21h.svg'

export function SignIn() {
  return (
    <div className="h-full flex">
      <div className="w-3/5">
        <div className="my-24 mx-36">
          <div className="mb-20">
            <img src={evermuseLogo} alt="Evermuse" width="170" height="21" />
          </div>

          <p className="text-3xl font-bold font-['DM_Sans'] text-zinc">Automate your user research</p>
          <p className="text-l font-medium font-['DM_Sans'] text-zinc my-2">
            Record, analyze, document, and categorize <br /> user stories from your meetings.
          </p>
          <GoogleSignIn />
          <MicrosoftSignIn />
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <p className="text-slate text-sm font-['Raleway'] underline">
                  Why does Evermuse require access to my calendar?
                </p>
              </TooltipTrigger>
              <TooltipContent className="bg-black text-white border-black max-w-[320px] leading-snug">
                Evermuse converts your customer calls into actionable product suggestions. In order to do that it needs
                to join your calls with customers. You can always change this later.
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
      <div className="w-2/5 bg-grey-100">
        <Sidebar />
      </div>
    </div>
  )
}
